import { render, staticRenderFns } from "./details-wares.vue?vue&type=template&id=571dc7a3&scoped=true"
import script from "./details-wares.vue?vue&type=script&lang=js"
export * from "./details-wares.vue?vue&type=script&lang=js"
import style0 from "./details-wares.vue?vue&type=style&index=0&id=571dc7a3&prod&lang=scss&scoped=true"
import style1 from "./details-wares.vue?vue&type=style&index=1&id=571dc7a3&prod&scoped=true&lang=css"
import style2 from "./details-wares.vue?vue&type=style&index=2&id=571dc7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dc7a3",
  null
  
)

export default component.exports